module.exports = __webpack_public_path__ + "static/media/86.a05a6de3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/86.svg
// module id = 172
// module chunks = 0